module.exports = __webpack_public_path__ + "static/media/submit-btn-hover.fe4a82b3.png";